module.exports = __webpack_public_path__ + "static/media/rm_06-34.afac5c3e.png";